import type { PageAudio } from './page-audio';

/** What counts as a control a click should sound for. */
const CLICKABLE_SELECTOR = 'button, a[href], [role="button"], [role="tab"], [role="menuitem"], [role="option"]';
const TOGGLE_SELECTOR = 'input[type="checkbox"], input[type="radio"], [role="switch"]';
/** Opt-out for a control that makes its own sound, or should make none. */
const SILENT_SELECTOR = '[data-ui-sound="none"]';

/**
 * Clicks on the page's controls sound (#260), from one listener rather
 * than every component: a click on a button or link plays `ui-click`, a
 * toggle `ui-toggle`. The game canvas is not a control, so a click into the
 * world is silent. Disabled controls fire no click, so they stay silent too.
 * Returns the uninstall.
 */
export function installUiSounds(target: Document, audio: PageAudio): () => void {
    const onClick = (event: MouseEvent): void => {
        if (!(event.target instanceof Element) || event.target.closest(SILENT_SELECTOR) !== null) {
            return;
        }
        if (event.target.closest(TOGGLE_SELECTOR) !== null) {
            audio.play('ui-toggle', 'ui-click');
            return;
        }
        if (event.target.closest(CLICKABLE_SELECTOR) !== null) {
            audio.play('ui-click');
        }
    };
    target.addEventListener('click', onClick, true);
    return () => target.removeEventListener('click', onClick, true);
}
